import { render, staticRenderFns } from "./vRetailer.vue?vue&type=template&id=0bbd52c2&"
import script from "./vRetailer.vue?vue&type=script&lang=js&"
export * from "./vRetailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports